// import React, { useEffect, useRef } from 'react';
// import { Card } from '../../../../Components/ui/card';
// import { Label } from '../../../../Components/ui/label';
// import { Input } from '../../../../Components/ui/input';
// import { Popover, PopoverContent, PopoverTrigger } from '../../../../Components/ui/popover';
// import { CalendarIcon } from "@radix-ui/react-icons";
// import { Calendar } from '../../../../Components/ui/calendar';
// import { useNavigate } from "react-router-dom";
// import { Wallet } from "lucide-react";
// import {
//   Select,
//   SelectTrigger,
//   SelectValue,
//   SelectContent,
//   SelectItem,
// } from '../../../../Components/ui/select';
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogDescription,
// } from '../../../../Components/ui/dialog';
// import { Button } from '../../../../Components/ui/button';
// import { useCampaignContext } from '../CampaignContext';
// import axios, { AxiosResponse } from "axios";
// import { useSelector } from "react-redux";
// import { RootState } from "@/src/State/store";
// import { useCampaignValidators } from "../hooks/useCampaignValidators";
// import * as ct from 'countries-and-timezones';
// import { useToast } from "../../../../Components/ui/use-toast";
// import { Toaster } from "../../../../Components/ui/toaster";


// const startTimeOptions = ['10:00', '11:00', '12:00', '13:00', '14:00'];
// const endTimeOptions = ['15:00', '16:00', '17:00', '18:00', '19:00'];
// type ScheduleCardProps = {
//   onSaveDraft: () => void;
// };

// const ScheduleCard: React.FC<ScheduleCardProps> = ({ onSaveDraft }) => {
//   const {
//     campaignStartDate,
//     setCampaignStartDate,
//     campaignEndDate,
//     setCampaignEndDate,
//     startTime,
//     setStartTime,
//     endTime,
//     setEndTime,
//     startDateError,
//     endDateError,
//     startTimeError,
//     endTimeError,
//     isSubmitAttempted,
//     selectedToCountryISO,
//     timezoneOptions,
//     setTimezoneOptions,
//     selectedTimeZone,
//     setSelectedTimeZone,
//     timeZoneError,
//     updateCampaignId,
//     isUpdateMode,
//     setHasInsufficientMessages,
//     isViewMode,
//     draftId,
//     setIsDraftToBeSavedAutomatically,
//     campaignName,
//     draftNames,
//     setIsDraftSubmitAttempted

//   } = useCampaignContext();

//   const { validateStartDate, validateEndDate, validateStartTime, validateEndTime, validateTimeZone, validateDraftName } = useCampaignValidators();

//   const toast = useToast();

//   const [isStartCalendarOpen, setStartCalendarOpen] = React.useState(false);
//   const [isEndCalendarOpen, setEndCalendarOpen] = React.useState(false);
//   const [isDialogOpen, setIsDialogOpen] = React.useState(false);
//   const [availableMessageCount, setAvailableMessageCount] = React.useState(0);

//   const [availableMessageApiCalled, setAvailableMessageApiCalled] = React.useState(false);


//   const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);

//   const accountId = useSelector((state: RootState) => state.authentication.account_id);

//   const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);

//   console.log("id", workspaceId);


//   const isMember = useSelector((state: RootState) => state.authentication.isInvited)



//   const navigate = useNavigate();

//   const { estimatedMessageNeeded } = useCampaignContext();



//   // Handles setting the selected date, validating it, and closing the calendar popover
//   const handleDateChange = (
//     date: Date | undefined,
//     setter: React.Dispatch<React.SetStateAction<string>>,
//     close: () => void,
//     validator: (value: string) => boolean
//   ) => {
//     if (date) {
//       const formatted = date.toLocaleDateString('en-GB'); // format: dd/mm/yyyy
//       setter(formatted); // update the state (e.g., setCampaignStartDate , setCampaignEndDate)
//       validator(formatted); // validate the selected value
//       close(); // close the calendar
//     }
//   };


//   const isStartDateDisabled = (date: Date) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     return date < today;
//   };

//   React.useEffect(() => {
//     if (!isUpdateMode) {

//       if (isViewMode) {
//         return
//       }


//       debugger;
//       if (!isSubmitAttempted) {

//         // if(estimatedMessageNeeded && availableMessageCount){
  
//         if (estimatedMessageNeeded != 0) {

//         if( availableMessageCount != null){

//           if(availableMessageApiCalled){

            


//           if (estimatedMessageNeeded > availableMessageCount) {
//             setIsDialogOpen(true);
//             setHasInsufficientMessages(true);
//           }
//           if (estimatedMessageNeeded <= availableMessageCount) {
//             setIsDialogOpen(false);
//             setHasInsufficientMessages(false);
//           }

//         }
//           }
//             }
//       }
//     }
//   }, [estimatedMessageNeeded, availableMessageCount]);

//   React.useEffect(() => {
//     if (!selectedToCountryISO) {
//       setTimezoneOptions([]);
//       setSelectedTimeZone(null);
//       return;
//     }

//     const country = ct.getCountry(selectedToCountryISO.toUpperCase());

//     if (!country || !country.timezones || country.timezones.length === 0) {
//       // No timezones for this country — load all timezones and let user decide
//       const allZones = Object.entries(ct.getAllTimezones()).map(([tz, info]) => ({
//         label: `${tz} (UTC${info.utcOffsetStr})`,
//         value: tz,
//       }));
//       setTimezoneOptions(allZones);
//       setSelectedTimeZone(null);
//       return;
//     }

//     const formattedZones = country.timezones.map((tz) => {
//       const tzInfo = ct.getTimezone(tz);
//       const offset = tzInfo?.utcOffsetStr || "";
//       return {
//         label: `${tz} (UTC${offset})`,
//         value: tz,
//       };
//     });

//     setTimezoneOptions(formattedZones);

//     if (formattedZones.length === 1) {
//       setSelectedTimeZone(formattedZones[0]);
//     } else {
//       setSelectedTimeZone(null);
//     }
//   }, [selectedToCountryISO]);




//   //API
//   const GetAvailableMessageCount = async () => {
//     try {
//       const response = await axios.get(
//         `${apiUrlAdvAcc}/GetAvailableMessageCount?accountId=${accountId}`
//       );

//       if (
//         response.data?.status === "Success" &&
//         typeof response.data.available_message_count === "number"
//       ) {
//         setAvailableMessageCount(response.data.available_message_count);
//       } else {
//       }
//     } catch (error) {
//     }
//   };


//   //API Call for Members View
//   const GetAvailableMessageCountByWorkspaceId = async () => {
//     try {
//       const response = await axios.get(
//         `${apiUrlAdvAcc}/GetAvailableMessageCountByWorkspaceId?workspaceId=${workspaceId}`
//       );

//       if (
//         response.data?.status === "Success" &&
//         typeof response.data.available_message_count === "number"
//       ) {
//         setAvailableMessageCount(response.data.available_message_count);
//         setAvailableMessageApiCalled(true);
//       } else {
//         console.warn(
//           "No available message count found for workspaceId:", workspaceId);
//       }
//     } catch (error) {
//       console.error(
//         "Error fetching available message count by workspace ID:",
//         error
//       );
//     }
//   };


//   useEffect(() => {
//     GetAvailableMessageCountByWorkspaceId();
//   }, [])

//   //UseEffect for checking default value in TimeZone
//   useEffect(() => {
//     if (selectedTimeZone?.value) {
//       validateTimeZone(selectedTimeZone.value);
//     }
//   }, [selectedTimeZone]);




//   return (
//     <Card className="w-[600px] mt-4 p-4 shadow-sm">
//       <div className="text-left">
//         <h3 className="text-base font-bold text-[#020617] text-left">Schedule</h3>
//         {/* Dates */}
//         <div className="flex gap-4 mt-4">
//           {/* Start Date */}
//           <div className="w-full">
//             <Label htmlFor="campaignStartDate" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//               Campaign start date
//             </Label>
//             <div className="relative w-full flex items-center border border-gray-300 rounded px-2 mt-1">
//               <input
//                 id="campaignStartDate"
//                 type="text"
//                 value={campaignStartDate}
//                 readOnly
//                 onClick={() => setStartCalendarOpen(true)}
//                 onFocus={() => setStartCalendarOpen(true)}
//                 placeholder="dd/mm/yyyy"
//                 disabled={isViewMode} // ✅ disable typing + greyed style
//                 className="w-full p-2 text-black placeholder-[#64748B] text-sm font-normal pr-10 bg-transparent 
//                focus:outline-none disabled:opacity-50 disabled:cursor-default"

//               />
//               <Popover open={isStartCalendarOpen} onOpenChange={setStartCalendarOpen}>
//                 <PopoverTrigger asChild>
//                   <button
//                     disabled={isViewMode}
//                     className="absolute right-2 top-1/2 transform -translate-y-1/2">
//                     <CalendarIcon className="text-gray-500" />
//                   </button>
//                 </PopoverTrigger>
//                 <PopoverContent>
//                   <Calendar
//                     initialFocus
//                     mode="single"
//                     defaultMonth={
//                       campaignStartDate
//                         ? new Date(campaignStartDate.split('/').reverse().join('-'))
//                         : new Date()
//                     }
//                     selected={
//                       campaignStartDate
//                         ? new Date(campaignStartDate.split('/').reverse().join('-'))
//                         : undefined
//                     }
//                     onSelect={(date) => {
//                       handleDateChange(
//                         date,
//                         setCampaignStartDate,
//                         () => setStartCalendarOpen(false),
//                         validateStartDate // ✅ pass validator
//                       );
//                       debugger
//                       setCampaignEndDate(""); // optional: reset end date
//                     }}
//                     disabled={isStartDateDisabled}
//                     numberOfMonths={1}
//                   />

//                 </PopoverContent>
//               </Popover>
//             </div>
//             {startDateError && isSubmitAttempted && (
//               <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                 {startDateError}
//               </p>)}
//           </div>

//           {/* End Date */}
//           <div className="w-full">
//             <Label htmlFor="campaignEndDate" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//               Campaign end date
//             </Label>
//             <div className="relative w-full flex items-center border border-gray-300 rounded px-2 mt-1">
//               <input
//                 id="campaignEndDate"
//                 type="text"
//                 value={campaignEndDate}
//                 readOnly
//                 onClick={() => setEndCalendarOpen(true)}
//                 onFocus={() => setEndCalendarOpen(true)}
//                 placeholder="dd/mm/yyyy"
//                 disabled={isViewMode} // ✅ disable typing + greyed style
//                 className="w-full p-2 text-black placeholder-[#64748B] text-sm font-normal pr-10 bg-transparent 
//                focus:outline-none disabled:opacity-50 disabled:cursor-default"
//               />


//               <Popover open={isEndCalendarOpen} onOpenChange={setEndCalendarOpen}>
//                 <PopoverTrigger asChild>
//                   <button
//                     disabled={isViewMode}
//                     className="absolute right-2 top-1/2 transform -translate-y-1/2">
//                     <CalendarIcon className="text-gray-500" />
//                   </button>
//                 </PopoverTrigger>
//                 <PopoverContent>
//                   <Calendar
//                     initialFocus
//                     mode="single"
//                     defaultMonth={
//                       campaignEndDate
//                         ? new Date(campaignEndDate.split('/').reverse().join('-'))
//                         : campaignStartDate
//                           ? new Date(campaignStartDate.split('/').reverse().join('-'))
//                           : new Date()
//                     }
//                     selected={
//                       campaignEndDate
//                         ? new Date(campaignEndDate.split('/').reverse().join('-'))
//                         : undefined
//                     }
//                     onSelect={(date) =>
//                       handleDateChange(
//                         date,
//                         setCampaignEndDate,
//                         () => setEndCalendarOpen(false),
//                         validateEndDate // ✅ pass validator
//                       )
//                     }
//                     disabled={(date: Date) =>
//                       campaignStartDate
//                         ? date < new Date(campaignStartDate.split("/").reverse().join("-"))
//                         : false
//                     }
//                     numberOfMonths={1}
//                   />

//                 </PopoverContent>
//               </Popover>
//             </div>

//             {endDateError && isSubmitAttempted && (
//               <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                 {endDateError}
//               </p>)}
//           </div>
//         </div>

//         {/* Delivery Window */}
//         <div className="flex gap-4 mt-4 ">
//           {/* Start Time */}
//           <div className="w-full">
//             <Label htmlFor="startTime" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//               Start Time
//             </Label>
//             <Select
//               value={startTime}
//               onValueChange={(value) => {
//                 setStartTime(value);
//                 validateStartTime(value);
//               }}
//               disabled={isViewMode}
//             >
//               <SelectTrigger className="mt-1 text-sm font-normal">
//                 {startTime ? (
//                   <SelectValue />
//                 ) : (
//                   <span className="pl-2 text-[#64748B] text-sm font-normal">
//                     Select Start Time
//                   </span>
//                 )}
//               </SelectTrigger>
//               <SelectContent>
//                 {startTimeOptions.map((time) => (
//                   <SelectItem key={time} value={time} className="cursor-pointer">
//                     {time}
//                   </SelectItem>
//                 ))}
//               </SelectContent>
//             </Select>

//             {startTimeError && isSubmitAttempted && (
//               <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                 {startTimeError}
//               </p>
//             )}
//           </div>

//           {/* End Time */}
//           <div className="w-full ">
//             <Label htmlFor="endTime" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//               End Time
//             </Label>
//             <Select
//               value={endTime}
//               onValueChange={(value) => {
//                 setEndTime(value);
//                 validateEndTime(value);
//               }}
//               disabled={isViewMode}

//             >
//               <SelectTrigger className="mt-1 text-sm font-normal">
//                 {endTime ? (
//                   <SelectValue />
//                 ) : (
//                   <span className="pl-2 text-[#64748B] text-sm font-normal">
//                     Select End Time
//                   </span>
//                 )}
//               </SelectTrigger>
//               <SelectContent>
//                 {endTimeOptions.map((time) => (
//                   <SelectItem key={time} value={time} className="cursor-pointer">
//                     {time}
//                   </SelectItem>
//                 ))}
//               </SelectContent>
//             </Select>

//             {endTimeError && isSubmitAttempted && (
//               <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                 {endTimeError}
//               </p>
//             )}
//           </div>
//         </div>



//         {/* Time Zone */}
//         <div className="flex gap-4 mt-4">
//           <div className="w-full">
//             <Label htmlFor="timeZone" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//               Target Country Time Zone
//             </Label>
//             <Select
//               disabled={isUpdateMode || isViewMode} // ✅ disables the entire select in update mode
//               value={selectedTimeZone?.value || ""}
//               onValueChange={(value) => {
//                 const selected = timezoneOptions.find((tz) => tz.value === value);
//                 if (selected) {
//                   setSelectedTimeZone(selected);
//                   validateTimeZone(selected.value); // use value for validation
//                 }
//               }}
//             >
//               <SelectTrigger className="mt-1 text-sm font-normal">
//                 {selectedTimeZone?.value && selectedTimeZone.value !== "none" ? (
//                   <span>{selectedTimeZone.label}</span>
//                 ) : (
//                   <span className="pl-2 text-[#64748B] text-sm font-normal">
//                     {timezoneOptions.length === 1 && timezoneOptions[0].value === "none"
//                       ? "No Time Zones Available"
//                       : "Select Time Zone"}
//                   </span>
//                 )}
//               </SelectTrigger>

//               <SelectContent>
//                 {timezoneOptions.length === 0 ? (
//                   <div className="px-4 py-2 text-sm text-[#64748B]">Please select a destination country first</div>
//                 ) : (
//                   timezoneOptions.map((tz) => (
//                     <SelectItem key={tz.value} value={tz.value} className="cursor-pointer">
//                       {tz.label}
//                     </SelectItem>
//                   ))
//                 )}
//               </SelectContent>
//             </Select>

//             {/* Optional validation error */}
//             {timeZoneError && isSubmitAttempted && (
//               <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                 {timeZoneError}
//               </p>
//             )}
//           </div>
//         </div>
//         {/* Estimated Message Needed */}
//         <div className="mt-4">
//           <Label htmlFor="estimatedMessages" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//             Estimated Message Needed
//           </Label>
//           <Input
//             id="estimatedMessages"
//             type="text"
//             value={estimatedMessageNeeded.toString()}
//             disabled
//             className="mt-1 text-black text-sm font-normal bg-[#E2E8F0] cursor-not-allowed w-1/2"
//           />
//         </div>
//       </div>

//       {/* Dialog */}
//       <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
//         <DialogContent className="max-w-2xl h-[225px]">
//           <DialogHeader>
//             <DialogTitle className="text-18px font-semibold text-[#09090B] mb-2 ">
//               Insufficient Message Balance
//             </DialogTitle>
//             <DialogDescription className="text-base font-medium text-[#71717A]">
//               Your available message count is not sufficient to launch this campaign.
//               Please top up your message balance to proceed.
//             </DialogDescription>
//           </DialogHeader>
//           <div className="flex justify-center mt-[-15px]">
//             {!isMember && (
//               <Button
//                 className="w-[150px] h-[45px] text-[14px] mt-2 font-normal"
//                 onClick={async () => {
//                   debugger;
//                   if (!draftId) {
//                     await onSaveDraft(); // This will now handle validation and navigation
//                   } else {
//                     navigate("/settings/Billing", {
//                       state: { route: "Billing" },
//                     });
//                   }
//                 }}
//               >
//                 <div className="flex pr-16 pl-16 pt-8 pb-8 gap-[10px]">
//                   <span className="flex justify-center items-center w-[48px] h-[16px]">
//   {draftId ? "Top Up" : "Save Draft & Top Up"}
// </span>
//                 </div>
//               </Button>
//             )}

//           </div>
//         </DialogContent>
//       </Dialog>
//     </Card>
//   );
// };

// export default ScheduleCard;


import React, { useEffect, useRef } from 'react';
import { Card } from '../../../../Components/ui/card';
import { Label } from '../../../../Components/ui/label';
import { Input } from '../../../../Components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../Components/ui/popover';
import { CalendarIcon } from "@radix-ui/react-icons";
import { Calendar } from '../../../../Components/ui/calendar';
import { useNavigate } from "react-router-dom";
import { Wallet } from "lucide-react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '../../../../Components/ui/select';
import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandItem,
  CommandList,
} from '../../../../Components/ui/command';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../../Components/ui/dialog';
import { Button } from '../../../../Components/ui/button';
import { useCampaignContext } from '../CampaignContext';
import axios, { AxiosResponse } from "axios";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import { useCampaignValidators } from "../hooks/useCampaignValidators";
import * as ct from 'countries-and-timezones';
import { useToast } from "../../../../Components/ui/use-toast";
import { Toaster } from "../../../../Components/ui/toaster";


const startTimeOptions = ['10:00', '11:00', '12:00', '13:00', '14:00'];
const endTimeOptions = ['15:00', '16:00', '17:00', '18:00', '19:00'];
type ScheduleCardProps = {
  onSaveDraft: () => void;
};

const ScheduleCard: React.FC<ScheduleCardProps> = ({ onSaveDraft }) => {
  const {
    campaignStartDate,
    setCampaignStartDate,
    campaignEndDate,
    setCampaignEndDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    startDateError,
    endDateError,
    startTimeError,
    endTimeError,
    isSubmitAttempted,
    selectedToCountryISO,
    timezoneOptions,
    setTimezoneOptions,
    selectedTimeZone,
    setSelectedTimeZone,
    timeZoneError,
    updateCampaignId,
    isUpdateMode,
    setHasInsufficientMessages,
    isViewMode,
    draftId,
    setIsDraftToBeSavedAutomatically,
    campaignName,
    draftNames,
    setIsDraftSubmitAttempted

  } = useCampaignContext();

  const { validateStartDate, validateEndDate, validateStartTime, validateEndTime, validateTimeZone, validateDraftName } = useCampaignValidators();

  const toast = useToast();

  const [isStartCalendarOpen, setStartCalendarOpen] = React.useState(false);
  const [isEndCalendarOpen, setEndCalendarOpen] = React.useState(false);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [availableMessageCount, setAvailableMessageCount] = React.useState(0);

  const [availableMessageApiCalled, setAvailableMessageApiCalled] = React.useState(false);

  const [tzOpen, setTzOpen] = React.useState(false);
  const [tzSearch, setTzSearch] = React.useState("");

  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);

  const accountId = useSelector((state: RootState) => state.authentication.account_id);

  const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);

  console.log("id", workspaceId);


  const isMember = useSelector((state: RootState) => state.authentication.isInvited)



  const navigate = useNavigate();

  const { estimatedMessageNeeded } = useCampaignContext();



  // Handles setting the selected date, validating it, and closing the calendar popover
  const handleDateChange = (
    date: Date | undefined,
    setter: React.Dispatch<React.SetStateAction<string>>,
    close: () => void,
    validator: (value: string) => boolean
  ) => {
    if (date) {
      const formatted = date.toLocaleDateString('en-GB'); // format: dd/mm/yyyy
      setter(formatted); // update the state (e.g., setCampaignStartDate , setCampaignEndDate)
      validator(formatted); // validate the selected value
      close(); // close the calendar
    }
  };


  const isStartDateDisabled = (date: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  React.useEffect(() => {
    if (!isUpdateMode) {

      if (isViewMode) {
        return
      }


      debugger;
      if (!isSubmitAttempted) {

        // if(estimatedMessageNeeded && availableMessageCount){
  
        if (estimatedMessageNeeded != 0) {

        if( availableMessageCount != null){

          if(availableMessageApiCalled){

            


          if (estimatedMessageNeeded > availableMessageCount) {
            setIsDialogOpen(true);
            setHasInsufficientMessages(true);
          }
          if (estimatedMessageNeeded <= availableMessageCount) {
            setIsDialogOpen(false);
            setHasInsufficientMessages(false);
          }

        }
          }
            }
      }
    }
  }, [estimatedMessageNeeded, availableMessageCount]);

  React.useEffect(() => {
    if (!selectedToCountryISO) {
      setTimezoneOptions([]);
      setSelectedTimeZone(null);
      return;
    }

    const country = ct.getCountry(selectedToCountryISO.toUpperCase());

    if (!country || !country.timezones || country.timezones.length === 0) {
      // No timezones for this country — load all timezones and let user decide
      const allZones = Object.entries(ct.getAllTimezones()).map(([tz, info]) => ({
        label: `${tz} (UTC${info.utcOffsetStr})`,
        value: tz,
      }));
      setTimezoneOptions(allZones);
      setSelectedTimeZone(null);
      return;
    }

    const formattedZones = country.timezones.map((tz) => {
      const tzInfo = ct.getTimezone(tz);
      const offset = tzInfo?.utcOffsetStr || "";
      return {
        label: `${tz} (UTC${offset})`,
        value: tz,
      };
    });

    setTimezoneOptions(formattedZones);

    if (formattedZones.length === 1) {
      setSelectedTimeZone(formattedZones[0]);
    } else {
      setSelectedTimeZone(null);
    }
  }, [selectedToCountryISO]);




  //API
  const GetAvailableMessageCount = async () => {
    try {
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetAvailableMessageCount?accountId=${accountId}`
      );

      if (
        response.data?.status === "Success" &&
        typeof response.data.available_message_count === "number"
      ) {
        setAvailableMessageCount(response.data.available_message_count);
      } else {
      }
    } catch (error) {
    }
  };


  //API Call for Members View
  const GetAvailableMessageCountByWorkspaceId = async () => {
    try {
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetAvailableMessageCountByWorkspaceId?workspaceId=${workspaceId}`
      );

      if (
        response.data?.status === "Success" &&
        typeof response.data.available_message_count === "number"
      ) {
        setAvailableMessageCount(response.data.available_message_count);
        setAvailableMessageApiCalled(true);
      } else {
        console.warn(
          "No available message count found for workspaceId:", workspaceId);
      }
    } catch (error) {
      console.error(
        "Error fetching available message count by workspace ID:",
        error
      );
    }
  };


  useEffect(() => {
    GetAvailableMessageCountByWorkspaceId();
  }, [])

  //UseEffect for checking default value in TimeZone
  useEffect(() => {
    if (selectedTimeZone?.value) {
      validateTimeZone(selectedTimeZone.value);
    }
  }, [selectedTimeZone]);

  const filteredTimezoneOptions = timezoneOptions.filter((tz) =>
    tz.label.toLowerCase().includes(tzSearch.toLowerCase())
  );


  return (
    <Card className="w-[600px] mt-4 p-4 shadow-sm">
      <div className="text-left">
        <h3 className="text-base font-bold text-[#020617] text-left">Schedule</h3>
        {/* Dates */}
        <div className="flex gap-4 mt-4">
          {/* Start Date */}
          <div className="w-full">
            <Label htmlFor="campaignStartDate" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
              Campaign start date
            </Label>
            <div className="relative w-full flex items-center border border-gray-300 rounded px-2 mt-1">
              <input
                id="campaignStartDate"
                type="text"
                value={campaignStartDate}
                readOnly
                onClick={() => setStartCalendarOpen(true)}
                onFocus={() => setStartCalendarOpen(true)}
                placeholder="dd/mm/yyyy"
                disabled={isViewMode} // ✅ disable typing + greyed style
                className="w-full p-2 text-black placeholder-[#64748B] text-sm font-normal pr-10 bg-transparent 
               focus:outline-none disabled:opacity-50 disabled:cursor-default"

              />
              <Popover open={isStartCalendarOpen} onOpenChange={setStartCalendarOpen}>
                <PopoverTrigger asChild>
                  <button
                    disabled={isViewMode}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2">
                    <CalendarIcon className="text-gray-500" />
                  </button>
                </PopoverTrigger>
                <PopoverContent>
                  <Calendar
                    initialFocus
                    mode="single"
                    defaultMonth={
                      campaignStartDate
                        ? new Date(campaignStartDate.split('/').reverse().join('-'))
                        : new Date()
                    }
                    selected={
                      campaignStartDate
                        ? new Date(campaignStartDate.split('/').reverse().join('-'))
                        : undefined
                    }
                    onSelect={(date) => {
                      handleDateChange(
                        date,
                        setCampaignStartDate,
                        () => setStartCalendarOpen(false),
                        validateStartDate // ✅ pass validator
                      );
                      debugger
                      setCampaignEndDate(""); // optional: reset end date
                    }}
                    disabled={isStartDateDisabled}
                    numberOfMonths={1}
                  />

                </PopoverContent>
              </Popover>
            </div>
            {startDateError && isSubmitAttempted && (
              <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                {startDateError}
              </p>)}
          </div>

          {/* End Date */}
          <div className="w-full">
            <Label htmlFor="campaignEndDate" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
              Campaign end date
            </Label>
            <div className="relative w-full flex items-center border border-gray-300 rounded px-2 mt-1">
              <input
                id="campaignEndDate"
                type="text"
                value={campaignEndDate}
                readOnly
                onClick={() => setEndCalendarOpen(true)}
                onFocus={() => setEndCalendarOpen(true)}
                placeholder="dd/mm/yyyy"
                disabled={isViewMode} // ✅ disable typing + greyed style
                className="w-full p-2 text-black placeholder-[#64748B] text-sm font-normal pr-10 bg-transparent 
               focus:outline-none disabled:opacity-50 disabled:cursor-default"
              />


              <Popover open={isEndCalendarOpen} onOpenChange={setEndCalendarOpen}>
                <PopoverTrigger asChild>
                  <button
                    disabled={isViewMode}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2">
                    <CalendarIcon className="text-gray-500" />
                  </button>
                </PopoverTrigger>
                <PopoverContent>
                  <Calendar
                    initialFocus
                    mode="single"
                    defaultMonth={
                      campaignEndDate
                        ? new Date(campaignEndDate.split('/').reverse().join('-'))
                        : campaignStartDate
                          ? new Date(campaignStartDate.split('/').reverse().join('-'))
                          : new Date()
                    }
                    selected={
                      campaignEndDate
                        ? new Date(campaignEndDate.split('/').reverse().join('-'))
                        : undefined
                    }
                    onSelect={(date) =>
                      handleDateChange(
                        date,
                        setCampaignEndDate,
                        () => setEndCalendarOpen(false),
                        validateEndDate // ✅ pass validator
                      )
                    }
                    disabled={(date: Date) =>
                      campaignStartDate
                        ? date < new Date(campaignStartDate.split("/").reverse().join("-"))
                        : false
                    }
                    numberOfMonths={1}
                  />

                </PopoverContent>
              </Popover>
            </div>

            {endDateError && isSubmitAttempted && (
              <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                {endDateError}
              </p>)}
          </div>
        </div>

        {/* Delivery Window */}
        <div className="flex gap-4 mt-4 ">
          {/* Start Time */}
          <div className="w-full">
            <Label htmlFor="startTime" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
              Start Time
            </Label>
            <Select
              value={startTime}
              onValueChange={(value) => {
                setStartTime(value);
                validateStartTime(value);
              }}
              disabled={isViewMode}
            >
              <SelectTrigger className="mt-1 text-sm font-normal">
                {startTime ? (
                  <SelectValue />
                ) : (
                  <span className="pl-2 text-[#64748B] text-sm font-normal">
                    Select Start Time
                  </span>
                )}
              </SelectTrigger>
              <SelectContent>
                {startTimeOptions.map((time) => (
                  <SelectItem key={time} value={time} className="cursor-pointer">
                    {time}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            {startTimeError && isSubmitAttempted && (
              <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                {startTimeError}
              </p>
            )}
          </div>

          {/* End Time */}
          <div className="w-full ">
            <Label htmlFor="endTime" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
              End Time
            </Label>
            <Select
              value={endTime}
              onValueChange={(value) => {
                setEndTime(value);
                validateEndTime(value);
              }}
              disabled={isViewMode}

            >
              <SelectTrigger className="mt-1 text-sm font-normal">
                {endTime ? (
                  <SelectValue />
                ) : (
                  <span className="pl-2 text-[#64748B] text-sm font-normal">
                    Select End Time
                  </span>
                )}
              </SelectTrigger>
              <SelectContent>
                {endTimeOptions.map((time) => (
                  <SelectItem key={time} value={time} className="cursor-pointer">
                    {time}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            {endTimeError && isSubmitAttempted && (
              <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                {endTimeError}
              </p>
            )}
          </div>
        </div>



        {/* Time Zone */}
        <div className="flex gap-4 mt-4">
          <div className="w-full">
            <Label htmlFor="timeZone" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
              Target Country Time Zone
            </Label>
            <Popover open={tzOpen} onOpenChange={(open) => {
              if (!isUpdateMode && !isViewMode) {
                setTzOpen(open);
                if (!open) setTzSearch("");
              }
            }}>
              <PopoverTrigger asChild>
                <button
                  disabled={isUpdateMode || isViewMode}
                  className="mt-1 w-full flex items-center justify-between border border-gray-200 rounded-md px-3 py-2 text-sm font-normal bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none"
                >
                  {selectedTimeZone?.value && selectedTimeZone.value !== "none" ? (
                    <span className="text-black">{selectedTimeZone.label}</span>
                  ) : (
                    <span className="text-[#64748B]">
                      {timezoneOptions.length === 0
                        ? "Please select a destination country first"
                        : "Select Time Zone"}
                    </span>
                  )}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-gray-500 ml-2 shrink-0"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </button>
              </PopoverTrigger>
              <PopoverContent className="w-[--radix-popover-trigger-width] p-0">
                <Command shouldFilter={false}>
                  <CommandInput
                    placeholder="Search timezone..."
                    value={tzSearch}
                    onValueChange={setTzSearch}
                  />
                  <CommandList>
                    {filteredTimezoneOptions.length === 0 ? (
                      <CommandEmpty>No timezone found.</CommandEmpty>
                    ) : (
                      filteredTimezoneOptions.map((tz) => (
                        <CommandItem
                          key={tz.value}
                          value={tz.value}
                          onSelect={() => {
                            setSelectedTimeZone(tz);
                            validateTimeZone(tz.value);
                            setTzOpen(false);
                            setTzSearch("");
                          }}
                          className="cursor-pointer"
                        >
                          {tz.label}
                        </CommandItem>
                      ))
                    )}
                  </CommandList>
                </Command>
              </PopoverContent>
            </Popover>

            {/* Optional validation error */}
            {timeZoneError && isSubmitAttempted && (
              <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                {timeZoneError}
              </p>
            )}
          </div>
        </div>
        {/* Estimated Message Needed */}
        <div className="mt-4">
          <Label htmlFor="estimatedMessages" className="mt-8 font-medium text-[#020617]" style={{ fontSize: '14px' }}>
            Estimated Message Needed
          </Label>
          <Input
            id="estimatedMessages"
            type="text"
            value={estimatedMessageNeeded.toString()}
            disabled
            className="mt-1 text-black text-sm font-normal bg-[#E2E8F0] cursor-not-allowed w-1/2"
          />
        </div>
      </div>

      {/* Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="max-w-2xl h-[225px]">
          <DialogHeader>
            <DialogTitle className="text-18px font-semibold text-[#09090B] mb-2 ">
              Insufficient Message Balance
            </DialogTitle>
            <DialogDescription className="text-base font-medium text-[#71717A]">
              Your available message count is not sufficient to launch this campaign.
              Please top up your message balance to proceed.
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-center mt-[-15px]">
            {!isMember && (
              <Button
                className="w-[150px] h-[45px] text-[14px] mt-2 font-normal"
                onClick={async () => {
                  debugger;
                  if (!draftId) {
                    await onSaveDraft(); // This will now handle validation and navigation
                  } else {
                    navigate("/settings/Billing", {
                      state: { route: "Billing" },
                    });
                  }
                }}
              >
                <div className="flex pr-16 pl-16 pt-8 pb-8 gap-[10px]">
                  <span className="flex justify-center items-center w-[48px] h-[16px]">
  {draftId ? "Top Up" : "Save Draft & Top Up"}
</span>
                </div>
              </Button>
            )}

          </div>
        </DialogContent>
      </Dialog>
    </Card>
  );
};

export default ScheduleCard;